'use client';

import Script from 'next/script';

export default function HotjarInitializer() {
	if (process.env.NEXT_PUBLIC_ENV !== 'production') {
		return null;
	}

	return <Script src={process.env.NEXT_PUBLIC_HOTJAR_SCRIPT_URL} strategy="afterInteractive" />;
}
